import { CONTENT_WIDTH } from "@/enums";
import { Button, Col } from "antd";
import { bool, func, string } from "prop-types";
import { useIntl } from "react-intl";

const SaveAndCancel = ({
  pageName,
  loading = false,
  saveOnClick,
  cancelOnClick,
  saveDisabled = false,
}) => {
  const intl = useIntl();

  return (
    <>
      <Col
        xxl={CONTENT_WIDTH.oneSixth}
        lg={CONTENT_WIDTH.oneQuarter}
        sm={CONTENT_WIDTH.half}
        xs={CONTENT_WIDTH.max}
      >
        <Button
          data-test-id={`${pageName}-cancel`}
          onClick={cancelOnClick}
          block
          disabled={loading}
        >
          {intl.formatMessage({ id: "general.cancel" })}
        </Button>
      </Col>
      <Col
        xxl={CONTENT_WIDTH.oneSixth}
        lg={CONTENT_WIDTH.oneQuarter}
        sm={CONTENT_WIDTH.half}
        xs={CONTENT_WIDTH.max}
      >
        <Button
          data-test-id={`${pageName}-save`}
          type="primary"
          onClick={saveOnClick}
          block
          loading={loading}
          disabled={saveDisabled}
          htmlType="submit"
        >
          {intl.formatMessage({ id: "general.save" })}
        </Button>
      </Col>
    </>
  );
};

SaveAndCancel.propTypes = {
  saveOnClick: func.isRequired,
  cancelOnClick: func.isRequired,
  pageName: string.isRequired,
  loading: bool,
  saveDisabled: bool,
};

export { SaveAndCancel };
